import styled from "@emotion/styled";
import { BLACK, COOL_BLUE, MIDDLE_GREY } from "../../styles/colors";
import * as S from "./MultiSelectBase.styles";
import { css } from "@emotion/react";

/** The shared panel minus its horizontal padding, so row highlights run edge to edge. Non-row
 *  children re-add the inset via InsetRow. */
export const Panel = styled(S.Panel)`
  padding: 8px 0;
`;

/** Re-adds the inset Panel gives up. */
export const InsetRow = css`
  padding: 0 10px 6px;
`;

/** One row of the list. */
export const Choice = styled("button")<{ selected?: boolean }>`
  display: block;
  width: 100%;
  text-align: left;

  border: none;
  /* Square, because the highlight reaches the panel edges. */
  border-radius: 0;
  box-sizing: border-box;
  /* is-active below is the only source of the highlight, so two rows can never be lit. */
  background: transparent;
  color: ${BLACK};
  font-size: 14px;
  font-weight: ${({ selected }) => (selected ? 600 : 400)};
  padding: 7px 10px;
  cursor: pointer;

  &.is-active {
    background: ${COOL_BLUE};
  }
`;

export const NoItems = styled("div")`
  padding: 8px 10px;
  color: ${MIDDLE_GREY};
  font-style: italic;
`;
